<template>
  <!-- 历史查询 -->
  <div class="page-container">
    <el-form
        :model="statusHistoryForm"
        ref="statusHistoryFormRef"
        class="form-panel statusHistory"
        label-position="left"
    >
      <el-row
          class="panel-top marginBottom"
          type="flex"
          justify="start"
          align="middle"
          :gutter="10"
      >
        <el-col :span="8">
          <el-input
              size="mini"
              placeholder="请输入单个客户业务编号；单个提单号；单个订单号进行查询"
              v-model="statusHistoryForm.orderNo"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-button
              class="el-button-search"
              @click="queryStatusHistory(statusHistoryForm.orderNo)"
              type="primary"
              size="small"
              plain
          >查询
          </el-button
          >
          <el-button
              @click="resetForm"
              type="primary"
              size="small"
              plain
          >重置
          </el-button
          >
        </el-col>
      </el-row>
      <el-row :gutter="5" class="statusHistoryHeader">
        <el-col :span="10" class="statusPic">
          <el-row class="panel-top">
            <el-col :span="7">
              <el-row class="flag-from">
               <!--  <img src="../../assets/images/add_imgs/flags.png"> -->
               <img v-show="fileKeyPol" :src="fileKeyPol" alt="" style="width: 100%;margin: 20px 0px 0px 70px" >
              </el-row>
              <el-row>
                <div class="polContainer">
                <div>{{ spOrder.polNameEn }}</div>
                <div>{{ spOrder.polName }}</div>
              </div>
              </el-row>
            </el-col>
            <el-col :span="6" style="text-align: center;padding-top:75px;">
              <img src="../../assets/img/status/shipArrow.png" alt="" style="width:80%">
            </el-col>
            <el-col :span="7">
              <el-row class="flag-from">
                  <img v-show="fileKeyPod" :src="fileKeyPod" alt="" style="width: 100%;margin: 20px 0px 0px 30px">
              </el-row>
              <el-row>
              <div class="podContainer">
                <div>{{ spOrder.podNameEn }}</div>
                <div>{{ spOrder.podName }}</div>
              </div>
             </el-row>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="13" class="statusInfo">
          <el-row class="statusInfoData">
            <el-col :span="12">
              <el-row>
                <el-col :span="8" class="statusInfoTitle">提单号:</el-col>
                <el-col :span="16">{{ spOrder.blNo }}</el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="8" class="statusInfoTitle">船名/航次:</el-col>
                <el-col :span="16">{{ spOrder.vesselNameEn }} / {{ spOrder.voyage }}</el-col>
              </el-row>
            </el-col>
          </el-row>
            <el-row class="statusInfoData">
            <el-col :span="12">
              <el-row>
                <el-col :span="8" class="statusInfoTitle">订单号:</el-col>
                <el-col :span="16">{{ spOrder.orderNo }}</el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="8" class="statusInfoTitle">停靠:</el-col>
                <el-col :span="16">{{ spOrder.terminalName }}</el-col>
              </el-row>
            </el-col>
          </el-row>
         <el-row class="statusInfoData">
            <el-col :span="12">
              <el-row>
                <el-col :span="8" class="statusInfoTitle">客户业务号:</el-col>
                <el-col :span="16">{{ spOrder.custBizNo }}</el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="8" class="statusInfoTitle">箱型箱量:</el-col>
                <el-col :span="16">{{ spOrder.ctnNum }}</el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
 <!--      <el-row
          class="panel-top"
          type="flex"
          justify="start"
          align="middle"
          :gutter="10"
          style="font-size: 18px;">
        <el-col :span="3" style="font-weight: bolder">提单号:</el-col>
        <el-col :span="5">{{ spOrder.blNo }}</el-col>
        <el-col :span="3" style="font-weight: bolder">订单号:</el-col>
        <el-col :span="5">{{ spOrder.orderNo }}</el-col>
        <el-col :span="3" style="font-weight: bolder">客户业务号:</el-col>
        <el-col :span="5">{{ spOrder.custBizNo }}</el-col>
      </el-row>
      <el-row class="panel-top">
        <el-col :span="8">
          <div class="polContainer">
            <div>{{ spOrder.polNameEn }}</div>
            <div>{{ spOrder.polName }}</div>
          </div>
        </el-col>
        <el-col :span="4" style="text-align: center;">
          <img src="../../assets/img/status/arrow.png" alt="" style="width:80%">
        </el-col>
        <el-col :span="8">
          <div class="podContainer">
            <div>{{ spOrder.podNameEn }}</div>
            <div>{{ spOrder.podName }}</div>
          </div>

        </el-col>
      </el-row>
      <el-row class="panel-top" style="font-size: 16px" align="middle">
        <el-col :span="3" style="font-weight: bolder">最后更新时间:</el-col>
        <el-col :span="4">{{ spOrder.lastModifyTime }}</el-col>
        <el-col :span="2" style="font-weight: bolder">船名/航次:</el-col>
        <el-col :span="8">{{ spOrder.vesselNameEn }} / {{ spOrder.voyage }}</el-col>
        <el-col :span="2" style="font-weight: bolder">停靠:</el-col>
        <el-col :span="2">{{ spOrder.terminalName }}</el-col>
        <el-col :span="2" style="font-weight: bolder">箱型箱量:</el-col>
        <el-col :span="1">{{ spOrder.ctnNum }}</el-col>
      </el-row> -->
      <el-row class="panel-top status-container">
        <el-col>
          <el-row type="flex" justify="center" align="middle" class="title-row">
            <el-col class="status-title" :span="4">状态名称</el-col>
            <!-- <el-col class="status-title" :span="4">状态时间</el-col> -->
            <el-col class="status-title" :span="11">状态描述</el-col>
            <el-col class="status-title" :span="4">数据来源</el-col>
            <el-col class="status-title" :span="5">记录时间</el-col>
          </el-row>
          <el-row>
            <el-collapse v-model="activeName">
              <el-collapse-item
                  :name="index"
                  v-for="(item, index) in spOrderStatus"
                  :key="index"
              >
                <template slot="title">
                  <div style="
                      width: 10px;
                      height: 30px;
                      border-right:3px solid transparent;
                      margin-right: 10px;"
                      :style="{borderTop:'30px solid '+item.color}"
                  ></div>
                  {{ item.stageName }}
                </template>
                <el-col class="status-content-list">
                  <!-- <el-row v-if=""></el-row> -->
<!--                   <el-row v-for="(item_list, item_index) in item.status" :key="item_index" class="status-content-row">
                    <el-col class="status-content-item" :span="4">{{ item_list.statusName ? item_list.statusName : '无' }}</el-col>
                    <el-col :span="13" class="status-content-item">{{ item_list.statusDescribe ? item_list.statusDescribe : '无' }}</el-col>
                    <el-col class="status-content-item" :span="3">{{ item_list.dataSource ? item_list.dataSource : '无' }}</el-col>
                    <el-col class="status-content-item" :span="4">{{ item_list.lastModifyTime ? item_list.lastModifyTime : '无' }}</el-col>
                  </el-row> -->
                   
                     <el-row v-if="item.status===undefined" class="status-content-row">
                        <el-col class="status-content-item" :span="4">--</el-col>
                        <el-col :span="11" class="status-content-item">--</el-col>
                        <el-col class="status-content-item" :span="4">--</el-col>
                        <el-col class="status-content-item" :span="5">--</el-col>
                     </el-row>
                   <el-row v-else-if="item.status!==undefined&&item.status.length!==0">
                       <el-row v-for="(item_list, item_index) in item.status" :key="item_index" class="status-content-row">
                        <el-col class="status-content-item" :span="4">{{ item_list.statusName ? item_list.statusName : '无' }}</el-col>
                        <el-col :span="11" class="status-content-item">{{ item_list.statusDescribe ? item_list.statusDescribe : '无' }}</el-col>
                        <el-col class="status-content-item" :span="4">{{ item_list.dataSource ? item_list.dataSource : '无' }}</el-col>
                        <el-col class="status-content-item" :span="5">{{ item_list.lastModifyTime ? item_list.lastModifyTime : '无' }}</el-col>
                     </el-row>
                  </el-row>
                    <el-row v-else class="status-content-row">
                        <el-col class="status-content-item" :span="4">--</el-col>
                        <el-col :span="11" class="status-content-item">--</el-col>
                        <el-col class="status-content-item" :span="4">--</el-col>
                        <el-col class="status-content-item" :span="5">--</el-col>
                     </el-row>
                </el-col>
              </el-collapse-item>
            </el-collapse>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import ScrollPane from "@/layout/components/TagsView/ScrollPane";
import { getSpOrder } from "@/api/ebOrder";
import { Uploader } from 'ec-light-vue';
import imageView from "@/views/appointment/imageView";
import { array } from 'jszip/lib/support';

export default {
  name: "StatusHistory",
  components: { ScrollPane,
            elUploader: Uploader,
          imageView
   },
  data() {
    return {
      activeName: [0,1,2,3,4,5,6,7,8,9,10,11],
      fileKeyPol: "",
      fileKeyPod: "",
      spOrder: {
        lastModifyTime: "",
        vesselNameEn: "",
        voyage: "",
        terminalName: "",
        ctnNum: "",
      },
      spOrderStatus: [],
      statusHistoryForm: {
        orderNo: "",
      },
      iconColor: ['rgba(248, 228, 230, 1)',' rgba(215, 238, 255, 1)',' rgba(202, 224, 255, 1)','rgba(230, 212, 232, 1)','rgba(242, 235, 236, 1)','rgba(255, 244, 224, 1)','rgba(208, 242, 228, 1)',' rgba(208, 226, 242, 1)','rgba(242, 208, 212, 1)','rgba(204, 235, 195, 1)',' rgba(208, 216, 242, 1)',' rgba(252, 231, 202, 1)','rgba(208, 242, 242, 1)','rgba(252, 202, 202, 1)'],
      statusHeaderBg: [' rgba(254, 250, 250, 1)','rgba(247, 252, 255, 1)','rgba(244, 249, 255, 1)',' rgba(251, 245, 255, 1)','rgba(252, 251, 251, 1)','rgba(255, 253, 250, 1)','rgba(250, 255, 252, 1)','rgba(250, 254, 255, 1)','rgba(255, 250, 252, 1)','rgba(252, 255, 250, 1)','rgba(250, 251, 255, 1)','rgba(255, 250, 247, 1)','rgba(250, 255, 255, 1)','rgba(255, 247, 247, 1)']
    };
  },
  async created() {

  },
  mounted() {
    let self = this;
    /**跳转到此界面接收值**/
    if (this.$route.params.orderNo) {
      self.orderNo = this.$route.params.orderNo;
      self.statusHistoryForm.orderNo = this.$route.params.orderNo;
      //订舱管理-编辑
      if (self.orderNo !== undefined) {
        self.queryStatusHistory(self.orderNo);
      }
    }
  },
  methods: {
    resetForm(){
      this.statusHistoryForm={}
    },
    queryStatusHistory(orderNo) {
      let self = this;
      if (self.statusHistoryForm.orderNo.trim().length === 0 || !orderNo) {
        return self.$coreMethods.message(
            "warning",
            "请输入单个客户业务编号；单个提单号；单个订单号进行查询"
        );
      }
      if (self.statusHistoryForm.orderNo.trim().length === 0) {
        self.statusHistoryForm.orderNo = orderNo;
      }
      self.getSpOrder(self.statusHistoryForm);
    },
    getSpOrder(data) {
      let self = this;
      getSpOrder(data).then((res) => {
        if ((res.success)) {
          let spOrderItem = res.records.spOrder;
          let fileKeys = {};
          if (spOrderItem.fileKeyPol && spOrderItem.fileKeyPod) {
            if (spOrderItem.fileKeyPol.length > 0 && spOrderItem.fileKeyPod.length > 0) {
              fileKeys = {
                fileKeyPol : spOrderItem.fileKeyPol,
                fileKeyPod : spOrderItem.fileKeyPod,
              };
            }
          }else if (spOrderItem.fileKeyPol) {
            if (spOrderItem.fileKeyPol.length > 0) {
              fileKeys = {
                fileKeyPol : spOrderItem.fileKeyPol,
              };
            }
          }else if (spOrderItem.fileKeyPod) {
            if (spOrderItem.fileKeyPod.length > 0) {
              fileKeys = {
                fileKeyPod : spOrderItem.fileKeyPod,
              };
            }
          }

          if (fileKeys != null) {
            console.log("开始查询国旗图片");
            self.getCountryFlag(fileKeys);
          }

          self.$coreMethods.message("success", "查询成功");
          self.spOrder = res.records?.spOrder ?? {};
          self.spOrder.lastModifyTime ? self.spOrder.lastModifyTime = self.$moment(self.spOrder.lastModifyTime).format("YYYY-MM-DD HH:ss:mm") : void 0
          self.spOrderStatus = res.records?.spOrderStatus ?? [];
          for(var i=0; i<self.spOrderStatus.length; i++){
             self.spOrderStatus[i].color=self.iconColor[i]
          }
          setTimeout(function(){
          var statsListBgColorArr = document.getElementsByClassName('el-collapse-item__header')
          var statsListBgColor= Array.prototype.slice.call(statsListBgColorArr)
              for(var a=0; a<statsListBgColor.length; a++){
                statsListBgColor[a].style.backgroundColor = self.statusHeaderBg[a]
              }
        },1000)
          self.spOrderStatus.forEach(item => {
            if (item.status) {
              let Status =[];
              item.status.forEach(itemStatus => {
                if(itemStatus.isOuter === 1){
                  itemStatus.lastModifyTime = self.$moment(itemStatus.lastModifyTime).format("YYYY-MM-DD HH:ss:mm");
                  itemStatus.statusTime = self.$moment(itemStatus.statusTime).format("YYYY-MM-DD HH:ss:mm");
                  Status.push(itemStatus)
                }
              });
              item.status = Status;
            }
          });
        }
      });
    },
    getCountryFlag(data) {
      let self = this;
       if (data.fileKeyPod && data.fileKeyPol) {
         self.fileKeyPod = Uploader.UploaderStrategy.getDownLoadUrl(data.fileKeyPod);
         self.fileKeyPol = Uploader.UploaderStrategy.getDownLoadUrl(data.fileKeyPol);
       } else if (data.fileKeyPod) {
           self.fileKeyPod = Uploader.UploaderStrategy.getDownLoadUrl(data.fileKeyPod);
       }else if (data.fileKeyPol) {
         self.fileKeyPol = Uploader.UploaderStrategy.getDownLoadUrl(data.fileKeyPol);
       }
    },
  },
};
</script>

<style scoped lang="scss">
.polContainer, .podContainer {
  min-height: 1px;
  margin: 20px 0;
  font-size: 18px;
}

.polContainer {
  text-align: end;
}

.podContainer {
  text-align: start;
}

.el-scrollbar ::v-deep .el-scrollbar__wrap {
  height: 125px;

  .el-scrollbar__view {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .node-content {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 118px;

      .node-content-img {
        width: 50px;
        background-size: 100% 100%;
      }

      .solid-style {
        height: 1px;
        border-top: 2px solid #e58660;
        width: 69px;
        position: absolute;
        top: 24px;
        left: 83px;
      }

      .dashed-style {
        height: 1px;
        border-top: 2px solid #d7d7d7;
        width: 69px;
        position: absolute;
        top: 24px;
        left: 83px;
      }

      .node-content-name {
        margin-top: 4px;
      }

      .node-content-date {
        font-size: 12px;
        margin-top: 4px;
        width: 80px;
        text-align: center;
        white-space: pre-wrap;
      }
    }
  }
}

.status-container {
  .title-row{
    background: rgba(252, 252, 253, 1);
    border: 1px solid rgba(224, 224, 224, 1);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 50px;
    padding: 0 6px;
  }
  .status-title {
    height: 30px;
    line-height: 30px;
    /* text-align: center; */
   /*  background-color: #ecf4ff; */
    border-right: 1px solid #ffffff;
  }

  .status-content-list {
    padding: unset;
    /* margin-bottom: 12px; */

    .status-content-item {
      text-align: unset;
      padding-left: 60px;
    }
  }

  ::v-deep .el-collapse {
   border-bottom: unset;

    .el-collapse-item {
      width: 100%;
      margin-bottom: 10px;

      .el-collapse-item__content {
        padding-bottom: 0px;
        background-color: #f2f2f2;
      }

      .el-collapse-item__header {
        font-size: 14px;
        color: #2f5597;
        background-color: #f2f2f2;
        height: 30px;
        .header-icon {
          margin: 3px 0px 0px 3px;
        }
      }
    }
  }
}
.status-container .status-title{
  background-color: unset;
  text-align: unset;
  padding-left: 60px;
}
.status-content-row{
  border: 1px solid rgba(151, 151, 151, 0.2);
  border-top: unset;
  padding: 20px 6px;
}
.flag-from{
  width: 60px;
  height: 60px;
 /*  background: url(../../assets/images/add_imgs/flags.png) no-repeat 82px 197px; */
}
::v-deep .el-collapse-item__wrap{
  border-bottom: unset;
}
::v-deep .bedBg{
  background-color: rgba(254, 250, 250, 1) !important;
}
</style>
